import { useBranding } from "@brickme/d2c-branding/src/browser/context.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type PurposeSelectionStepProps = {
	readonly onPurposeSelect: (purpose: "myself" | "someone_else") => void;
};

export default function PurposeSelectionStep({
	onPurposeSelect,
}: PurposeSelectionStepProps) {
	const t = useTranslator();
	const branding = useBranding();
	const { purposeMyself, purposeGift } = branding.getStartedImages;
	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">{t("Who's it for?")}</h1>

				<div className="purpose-options">
					<button
						className="purpose-option"
						onClick={() => onPurposeSelect("myself")}
						type="button"
					>
						<div className="purpose-option-content">
							<div className="purpose-icon-section">
								<div className="purpose-icon">
									<img src={purposeMyself} alt={t("For myself")} />
								</div>
							</div>
							<div className="purpose-header-section">
								<h2>{t("For myself")}</h2>
							</div>
							<div className="purpose-text-section">
								<p>{t("I want to create something for my own space")}</p>
							</div>
						</div>
					</button>

					<button
						className="purpose-option"
						onClick={() => onPurposeSelect("someone_else")}
						type="button"
					>
						<div className="purpose-option-content">
							<div className="purpose-icon-section">
								<div className="purpose-icon">
									<img src={purposeGift} alt={t("For someone else")} />
								</div>
							</div>
							<div className="purpose-header-section">
								<h2>{t("For someone else")}</h2>
							</div>
							<div className="purpose-text-section">
								<p>{t("I want to provide a gift for someone special")}</p>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>
	);
}
